import React, { useState } from "react";
import { createStage, checkCollision } from "../gameHelpers";

//styledComponents
import { StyledTetrisWrapper, StyledTetris } from "./styles/StyledTetris";

//Custom Hooks
import { useInterval } from "../hooks/useInterval";
import { usePlayer } from "../hooks/usePlayer";
import { useStage } from "../hooks/useStage";
import { useGameStatus } from "../hooks/useGameStatus";

//Components
import Stage from "./Stage";
import Display from "./Display";
import StartButton from "./StartButton";
import Tutorial from './Tutorial';

const Tetris = () => {
  const [dropTime, setDropTime] = useState(null);
  const [gameOver, setGameOver] = useState(false);

  const [player, updatePlayerPos, resetPlayer, playerRotate] = usePlayer();
  const [stage, setStage, rowsCleared] = useStage(player, resetPlayer);
  const [score, setScore, rows, setRows, level, setLevel] =
    useGameStatus(rowsCleared);

  console.log("re-render");

  const movePlayer = (dir) => {
    if (!checkCollision(player, stage, { x: dir, y: 0 })) {
      updatePlayerPos({ x: dir, y: 0 });
    }
  };

  const keyUp = ({ keyCode }) => {
    console.log("interval on");
    if (!gameOver) {
      if (keyCode === 40) {
        setDropTime(1000 / (level + 1) + 200);
      }
    }
  };

  const startGame = () => {
    //reset tat ca
    setStage(createStage());
    setDropTime(1000);
    resetPlayer();
    setScore(0);
    setRows(0);
    setLevel(0);
    setGameOver(false);
  };

  const drop = () => {
    //tang lv khi nguoi choi awn dc 10 hang
    if (rows > (level + 1) * 10) {
      setLevel((prev) => prev + 1);
      //tang toc do (kho hon)
      setDropTime(1000 / (level + 1) + 200);
    }
    if (!checkCollision(player, stage, { x: 0, y: 1 })) {
      updatePlayerPos({ x: 0, y: 1, collided: false });
    } else {
      if (player.pos.y < 1) {
        console.log("GAME OVER!!!");
        setGameOver(true);
        setDropTime(null);
      }
      updatePlayerPos({ x: 0, y: 0, collided: true });
    }
  };

  const dropPlayer = () => {
    console.log("interval off");
    setDropTime(null);
    drop();
  };
  useInterval(() => {
    drop();
  }, dropTime);

  const move = ({ keyCode }) => {
    //e.keyCode
    if (!gameOver) {
      if (keyCode === 37) {
        movePlayer(-1);
      } else if (keyCode === 39) {
        movePlayer(1);
      } else if (keyCode === 40) {
        dropPlayer();
      } else if (keyCode === 38) {
        playerRotate(stage, 1);
      }
    }
  };

  return (
    <StyledTetrisWrapper
      role="button"
      tabIndex="0"
      onKeyDown={(e) => move(e)}
      onKeyUp={keyUp}
    >
      <StyledTetris>
        <Stage stage={stage} />
        <aside>
          {gameOver ? (
            <Display gameOver={gameOver} text="gameOver" />
          ) : (
            <div>
              <Display text={`Score:${score}`} />
              <Display text={`Rows:${rows}`} />
              <Display text={`Level:${level}`} />
            </div>
          )}

          <StartButton callback={startGame} />
        </aside>
        <Tutorial />
      </StyledTetris>
    </StyledTetrisWrapper>
  );
};

export default Tetris;

